const beneficiaryDateViewTemplate = `
<input type="text"
	inputmode="numeric"
	name="{{ctrl.name}}"
	title="{{ctrl.title}}"
	id="{{ctrl.id}}"
	class="{{ctrl.class}}"
	ng-model="ctrl.model"
	ng-model-options="{ updateOn: 'blur', allowInvalid: true }"
	ng-required="ctrl.isRequired()"
	ng-disabled="ctrl.isDisabled()"
    mask-date="{{ctrl.maskDate}}"
	min-date="{{ctrl.minDate}}"
    allow-empty="{{ctrl.allowEmpty}}"
	allow-future-date="{{ctrl.allowFutureDate}}"
	allow-current-date="{{ctrl.allowCurrentDate}}"
	ui-options="ctrl.uiOptions"
	model-view-value="false"
	placeholder=""
	autocomplete="off"
	ng-blur="ctrl.dateBlur({$event: $event});"
	ng-focus="ctrl.dateFocus({$event: $event});"
	pw-beneficiary-date-validator
/>
`;
export default beneficiaryDateViewTemplate;
